import useHistoryTableFilterStore, {
	HistoryTableFilterStore,
} from 'src/stores/historyTableFilterStore/useHistoryTableFilterStore';
import { SelectOption } from 'src/components/primitives/Select/hooks/types';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';
import Select from 'src/components/primitives/Select/Select';
import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';
import PortfolioHistoryTableMarketFilter from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableMarketFilter';

const TYPE_FILTER_OPTIONS: SelectOption<
	HistoryTableFilterStore['deposits']['type']
>[] = [
	{ label: 'All', value: 'all' },
	{ label: 'Deposit', value: 'deposit' },
	{ label: 'Withdraw', value: 'withdraw' },
];

export default function PortfolioHistoryBalancesTableControls() {
	const marketFilter = useHistoryTableFilterStore(
		(s) => s.getFilterState('deposits')['spotMarketSymbol']
	);
	const typeFilter = useHistoryTableFilterStore(
		(s) => s.getFilterState('deposits')['type']
	);
	const setHistoryTableFilterState = useHistoryTableFilterStore((s) => s.set);

	const handleMarketFilterChange = (selectedMarket: string) => {
		setHistoryTableFilterState((s) => {
			s.deposits.spotMarketSymbol = selectedMarket;
			s.deposits.currentUiPage = 0;
		});
	};

	const handleTypeFilterChange = (
		selectedType: HistoryTableFilterStore['deposits']['type']
	) => {
		setHistoryTableFilterState((s) => {
			s.deposits.type = selectedType;
			s.deposits.currentUiPage = 0;
		});
	};

	const {
		open,
		onOpenChange,
		value,
		onValueChange,
		selectOptions,
		selectedOption,
	} = useSelect({
		selectedValue: typeFilter,
		onSelectedValueChange: handleTypeFilterChange,
		options: TYPE_FILTER_OPTIONS,
	});

	return (
		<PortfolioHistoryTableControls historyType="deposits" exportType="deposits">
			<PortfolioHistoryTableMarketFilter
				marketType="spot"
				marketFilter={marketFilter}
				handleMarketFilterChange={handleMarketFilterChange}
				id="portfolio-history-balances-table-market-filter"
			/>
			<Select.Root
				open={open}
				onOpenChange={onOpenChange}
				value={value}
				onValueChange={onValueChange}
			>
				<Select.Trigger label="Type" className="min-w-38">
					{selectedOption?.label}
				</Select.Trigger>
				<Select.Options>
					{selectOptions.map((option) => (
						<Select.Option key={option.value} value={option.value}>
							{option.label}
						</Select.Option>
					))}
				</Select.Options>
			</Select.Root>
		</PortfolioHistoryTableControls>
	);
}
